import aspida from '@aspida/axios'
import axios from 'axios'
import qs from 'qs'

import api from '@/api/$api'
import { useHeaderTokenState } from '@/globalStates'

export const useApiClient = () => {
  const headerToken = useHeaderTokenState()
  const isReady = headerToken.deviceId !== '' && headerToken.jwt !== ''

  const apiClient = api(
    aspida(axios, {
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      },
      withCredentials: true,
      baseURL:
        process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:8080/api/v1',
      headers: {
        'Device-ID': headerToken.deviceId ?? '',
        Authorization: headerToken.jwt ? `Bearer ${headerToken.jwt}` : '',
      },
    })
  )

  return { apiClient, isReady }
}
